import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({
    container: {
        // margin: '10px 0px 30px 0px'
    },
    colorComponente:{
        backgroundColor: 'white',
        alignItems: "center",        
    },

    lineaDegradadaBottom:{
        position: "relative",
        bottom: 0,
        left: 0,
        width: "100%",
        height: 4,
        background: `linear-gradient(344deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,212,255,1) 100%)`,
    },
    centerTitle: {
        textAlign: 'center',
        backgroundColor:'black',
        color: 'white',
    },
    containerInformacion: {
        marginLeft: '30px',
        fontSize: '14px',
    },
    listTitle:{
        marginLeft: '40px'
    },
    listInfo:{
        marginLeft: '50px'
    },
    description: {
        fontSize: '14px'
    },
}))